const base = process.env.VUE_APP_REQUEST_BASE || window.location.origin;
export default {
    baseUrl: base,
    basePrintUrl: base + '/pc/prints',
    socketUrl: base.replace('https', 'wss').replace('http', 'ws') + '/hunyuan'
};
